import type { DailySalesReport, DeliveryRiderRow, StaffSalesRow } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const dailySalesKeys = {
  daily: (filters: ReportFilters) => ['reports', 'sales', 'daily', filters] as const,
  byStaff: (filters: ReportFilters) => ['reports', 'sales', 'by-staff', filters] as const,
  deliveries: (filters: ReportFilters) => ['reports', 'deliveries', filters] as const,
};

/**
 * All three endpoints return their whole (small, aggregated) result set, so
 * only branch, range and document type go to the server; search and filters
 * are applied on the page.
 */
function rangeQuery(filters: ReportFilters): string {
  return queryString({ branchId: filters.branchId, from: filters.from, to: filters.to, docType: filters.docType });
}

export function fetchDailySales(filters: ReportFilters, signal?: AbortSignal): Promise<DailySalesReport> {
  return portalApi.get<DailySalesReport>(`/portal/reports/sales/daily${rangeQuery(filters)}`, { signal });
}

/** Both attributions in one list — filter on `attribution` ('salesPerson' | 'cashier'). */
export function fetchSalesByStaff(filters: ReportFilters, signal?: AbortSignal): Promise<StaffSalesRow[]> {
  return portalApi.get<StaffSalesRow[]>(`/portal/reports/sales/by-staff${rangeQuery(filters)}`, { signal });
}

export function fetchDeliveries(filters: ReportFilters, signal?: AbortSignal): Promise<DeliveryRiderRow[]> {
  return portalApi.get<DeliveryRiderRow[]>(`/portal/reports/deliveries${rangeQuery(filters)}`, { signal });
}
